export default "__VITE_ASSET__CTmbIE$a__"